import debounce from 'lodash/debounce';
import { isMobile } from '@common/utils/responsive';
import { Modal } from '@common/vanilla_ui/general';
import { modalEvents } from '@common/vanilla_ui/general/modal';
import RCB from '@scaler_landing/pages/contact_us_widget/rcb';
import {
  setAttribution,
} from '@common/vanilla_ui/tracking/attribution';
import {
  // CALLBACK_MODES,
  QUERY_PARAMS,
} from './constants';
import Tracking from './tracking';

const REQUEST_CALLBACK_CONTAINER = 'request-callback-container';
const CONTACT_US_WIDGET_CONTAINER = 'contact-us-widget-container';
const CONTACT_US_WIDGET_BUTTON = 'contact-us-widget';
// const REQUEST_CALLBACK_SUCCESS_CONTAINER = 'request-callback-success';
const REQUEST_CALLBACK_FORM = 'request-callback-form';
const CONTACT_US_STRIP = 'contact-us-strip';
const INFO_TEXT_STRIP = 'contact-us-widget__item--text';
const REQUEST_CALLBACK_STRIP = 'request-callback-strip';
const REQUEST_CALLBACK_MODAL = 'request-callback-modal';
const DEFAULT_PROGRAM = 'academy';
const DEFAULT_RCB_INTENT = 'rcb_widget';

const REQUEST_CALLBACK_STRIP_DISABLED_PAGES = [
  '/enterprise',
  '/settings/scaler',
  '/careers',
  '/careers-business',
  '/scaler-verse',
];

const RCB_CONTACT_US_POPUP_DISABLED_PAGES = [
  '/events',
  '/event',
];

const RCB_TALK_TO_US_POPUP_PAGES = [
  '/academy',
  '/devops-course',
  '/data-science-course',
  '/courses',
];

const REQUEST_CALLBACK_CTAS = [
  ['us-academy-request-callback', 'rcb'], // Should nt be here
  ['tuition-fee-request-callback', 'rcb'],
  ['banner-webinar-request-callback', 'landing'],
  ['banner-request-callback', 'rcb'],
  ['people-webinar-request-callback', 'landing'],
  ['masterclass-webinar-request-callback', 'landing'],
  ['masterclass-request-callback', 'rcb'],
  ['header-request-callback', 'landing'],
  ['fab-request-callback', 'landing'],
  ['course-fab-request-callback', 'landing'],
  ['course-banner-request-callback', 'landing'],
  ['faq-webinar-request-callback', 'landing'],
  [`${REQUEST_CALLBACK_STRIP}-action`, 'rcb', DEFAULT_PROGRAM, 'rcb_strip'],
  ['event-request-callback', 'rcb'],
  ['academy-request-callback', 'rcb', DEFAULT_PROGRAM,
    'rcb_academy_program_card'],
  ['data-science-request-callback', 'rcb', 'data_science',
    'rcb_data_science_program_card'],
  ['neovarsity-request-callback', 'rcb', 'neovarsity',
    'rcb_neovarsity_program_card'],
  ['data-science-banner-request-callback', 'rcb', 'data_science',
    'rcb_landing_page_banner'],
  ['pricing-section-request-callback',
    'rcb', DEFAULT_PROGRAM, 'pricing_banner_rcb_cta'],
];

const PROGRAM_PRODUCT_MATCHING = {
  academy: 'software_development',
  data_science: 'data_science',
  neovarsity: 'neovarsity',
};

// const callBackRequested = false;
let isDefaultCountry = true;

const toggleDisplayStyle = (element, displayValue) => {
  const el = element;
  if (el) {
    el.style.display = displayValue;
  }
};

export default function initialiseNewRcb() {
  // clipboad event
  const phoneNumberCta = document.getElementById('copy-phone-number');
  phoneNumberCta.addEventListener('click', () => {
    navigator.clipboard.writeText('01205096015');
    phoneNumberCta.style.color = 'grey';
  });

  const formFlowEl = document.querySelector('#request-callback-form');
  isDefaultCountry = formFlowEl?.getAttribute(
    'data-default-country',
  ) === 'true';
  const requestCallbackHiddenClass = `${REQUEST_CALLBACK_CONTAINER}--hidden`;
  const requestCallbackStripEl = document.getElementById(
    REQUEST_CALLBACK_STRIP,
  );
  const contactUsContainer = document.getElementById(
    CONTACT_US_WIDGET_CONTAINER,
  );
  const widgetButton = document.getElementById(
    CONTACT_US_WIDGET_BUTTON,
  );
  const callUsDirectlyEl = document.getElementById('contact-us-directly');
  const scalerRcbEL = document.getElementById('scaler-rcb');
  const callUsDirectlyColseEl = document.getElementById(
    'contact-us-directly-close',
  );
  const scalerRcbColseEl = document.getElementById(
    'scaler-rcb-close',
  );
  const scalerRcbSuccessCloseEl = document.getElementById(
    'rcb-success-close',
  );
  const phoneWidget = document.getElementById('phone-widget');
  const callUsPhoneWidget = document.getElementById(
    'call-us-phone-widget',
  );
  const chatWidget = document.getElementById('chat-widget');
  const widgetIcon = document.getElementById('widget-icon');
  const widgetClose = document.getElementById('widget-close');
  const floatingContainer = document.getElementById(
    REQUEST_CALLBACK_CONTAINER,
  );
  const requestCallbackFormCloseEl = document.getElementById(
    `${REQUEST_CALLBACK_FORM}-close`,
  );

  const contactUsStripEl = document.getElementById(CONTACT_US_STRIP);

  const pathName = window.location.pathname;
  if (
    pathName
    && !REQUEST_CALLBACK_STRIP_DISABLED_PAGES.includes(
      pathName.replace(/\/+$/g, ''),
    )
  ) {
    requestCallbackStripEl.classList.remove(
      `${REQUEST_CALLBACK_STRIP}--hidden`,
    );
  }

  const toggleCallUsWidget = (displayStyle) => {
    if (isMobile()) {
      toggleDisplayStyle(callUsPhoneWidget, displayStyle);
    }
  };

  const isWidgetOpen = () => {
    if (contactUsContainer.style.display === 'none') {
      return true;
    }
    if (widgetClose.style.display !== 'none') {
      return true;
    }

    return false;
  };

  const toggleAnimation = (className, add = true) => {
    if (add) {
      chatWidget.classList.add(className);
      phoneWidget.classList.add(className);
      callUsPhoneWidget.classList.add(className);
      widgetButton.classList.add(className);
    } else {
      chatWidget.classList.remove(className);
      phoneWidget.classList.remove(className);
      callUsPhoneWidget.classList.remove(className);
      widgetButton.classList.remove(className);
    }
  };

  const openCallbackContainer = () => {
    phoneWidget.click();
    widgetButton.click();
  };

  const closeRequestCallbackContainer = (modalId = null) => {
    if (modalId && modalId !== REQUEST_CALLBACK_MODAL) {
      return;
    }
    toggleDisplayStyle(phoneWidget, 'none');
    toggleDisplayStyle(chatWidget, 'none');
    toggleDisplayStyle(callUsPhoneWidget, 'none');
    toggleCallUsWidget('none');
    toggleDisplayStyle(widgetIcon, '');
    toggleDisplayStyle(widgetClose, 'none');

    if (!isDefaultCountry) {
      Modal.close(REQUEST_CALLBACK_MODAL);
    } else {
      floatingContainer.classList.add(requestCallbackHiddenClass);
    }
  };

  modalEvents.on('backdrop:dismissed', closeRequestCallbackContainer);
  modalEvents.on('dismissed', closeRequestCallbackContainer);

  const openRequestCallbackPopup = (e, cta, program = DEFAULT_PROGRAM) => {
    e.stopPropagation();
    openCallbackContainer({ callbackCtaId: cta, program });
  };

  const setCtaClickAttribution = (intent, program) => {
    setAttribution(intent, {
      program: PROGRAM_PRODUCT_MATCHING[program],
    });
  };

  REQUEST_CALLBACK_CTAS.forEach(([callbackCtaId, cta, program, intent]) => {
    const el = document.getElementById(callbackCtaId);
    if (el) {
      el.addEventListener(
        'click',
        e => {
          openRequestCallbackPopup(e, cta, program || DEFAULT_PROGRAM);
          setCtaClickAttribution(
            intent || DEFAULT_RCB_INTENT,
            program || DEFAULT_PROGRAM,
          );
        },
      );
    }
  });

  const closeAllWidget = () => {
    const iframeEl = document.getElementById('home');
    if (iframeEl) iframeEl.style.display = 'none';
    window.closeWidget();
    callUsDirectlyEl.classList.remove('slide-in-animate');
    callUsDirectlyEl.classList.add('slide-out-animate');
    scalerRcbEL.classList.remove('slide-in-animate');
    scalerRcbEL.classList.add('slide-out-animate');
  };

  function closeMenu() {
    widgetButton.click();
    closeAllWidget();
    toggleAnimation('slide-menu', false);
    toggleAnimation('slide-menu-for-chat', false);
  }

  widgetClose.addEventListener('click', () => {
    toggleAnimation('slide-menu', false);
    toggleAnimation('slide-menu-for-chat', false);
    closeAllWidget();
  });

  callUsPhoneWidget.addEventListener('click', () => {
    closeAllWidget();
    toggleAnimation('slide-menu');
    toggleAnimation('slide-menu-for-chat', false);
    callUsDirectlyEl.classList.remove('slide-out-animate');
    callUsDirectlyEl.classList.add('slide-in-animate');
  });

  callUsDirectlyColseEl.addEventListener('click', () => {
    toggleAnimation('slide-menu', false);
    toggleAnimation('slide-menu-for-chat', false);
    callUsDirectlyEl.classList.remove('slide-in-animate');
    callUsDirectlyEl.classList.add('slide-out-animate');
  });

  scalerRcbColseEl.addEventListener('click', () => {
    toggleAnimation('slide-menu', false);
    toggleAnimation('slide-menu-for-chat', false);
    scalerRcbEL.classList.remove('slide-in-animate');
    scalerRcbEL.classList.add('slide-out-animate');
  });

  scalerRcbSuccessCloseEl.addEventListener('click', () => {
    closeMenu();
  });

  chatWidget.addEventListener('click', () => {
    const iframeEl = document.getElementById('home');
    if (iframeEl) iframeEl.style.display = 'block';
    window.openWidget();
    callUsDirectlyEl.classList.remove('slide-in-animate');
    callUsDirectlyEl.classList.add('slide-out-animate');
    scalerRcbEL.classList.remove('slide-in-animate');
    scalerRcbEL.classList.add('slide-out-animate');
    toggleAnimation('slide-menu', false);
    toggleAnimation('slide-menu-for-chat');
  });

  phoneWidget.addEventListener('click', (e) => {
    e.stopPropagation();
    closeAllWidget();
    toggleAnimation('slide-menu');
    toggleAnimation('slide-menu-for-chat', false);
    scalerRcbEL.classList.add('slide-in-animate');
    scalerRcbEL.classList.remove('slide-out-animate');
    setCtaClickAttribution(
      DEFAULT_RCB_INTENT,
      DEFAULT_PROGRAM,
    );
  });

  widgetButton.addEventListener('click', (event) => {
    event.stopPropagation();
    if (widgetIcon.style.display === 'none') {
      closeRequestCallbackContainer();
      contactUsContainer.classList.remove('container-open');
    } else {
      contactUsContainer.classList.add('container-open');
      toggleDisplayStyle(phoneWidget, 'flex');
      toggleDisplayStyle(chatWidget, 'flex');
      toggleDisplayStyle(callUsPhoneWidget, 'flex');
      toggleCallUsWidget('flex');
      toggleDisplayStyle(widgetIcon, 'none');
      toggleDisplayStyle(widgetClose, '');
    }
  });

  requestCallbackFormCloseEl?.addEventListener('click', (event) => {
    event.stopPropagation();
    closeRequestCallbackContainer();
  });

  const isContactUsPopupDisabled = pathName
  && RCB_CONTACT_US_POPUP_DISABLED_PAGES.some(
    (disabledPage) => pathName.startsWith(disabledPage),
  );

  const shouldAddTalkToUsText = pathName
  && RCB_TALK_TO_US_POPUP_PAGES.some(
    (page) => pathName.startsWith(page),
  );

  if (!isContactUsPopupDisabled) {
    window.addEventListener('scroll', debounce(() => {
      if (
        !isWidgetOpen()
          && !contactUsStripEl.classList.contains(INFO_TEXT_STRIP)
      ) {
        if (shouldAddTalkToUsText) contactUsStripEl.innerText = 'Talk to us';
        contactUsStripEl.classList.remove(
          `${INFO_TEXT_STRIP}--hidden`,
        );
        contactUsStripEl.classList.add(INFO_TEXT_STRIP);
      }
    }, 1000, { leading: true, trailing: false }));

    window.addEventListener('scroll', debounce(() => {
      if (!contactUsStripEl.classList.contains(`${INFO_TEXT_STRIP}--hidden`)) {
        contactUsStripEl.classList.add(`${INFO_TEXT_STRIP}--hidden`);
        contactUsStripEl.classList.remove(INFO_TEXT_STRIP);
      }
    }, 1000));
  }

  const shouldAuthenticateMobile = formFlowEl.getAttribute(
    'data-rcb-enable-mobile-authentication',
  ) === 'true'
  || formFlowEl.getAttribute('data-enable-mobile-authentication') === 'true';
  if (shouldAuthenticateMobile) {
    RCB();
  }

  // Handle queryParams
  const handleQueryParams = () => {
    const queryString = window.location.search;
    const queryParams = new URLSearchParams(queryString);
    if (queryParams.get(QUERY_PARAMS.openCalendly) === 'true') {
      openCallbackContainer({ callbackCtaId: 'landing' });
    } else if (queryParams.get(QUERY_PARAMS.requestCallback) === 'true') {
      openCallbackContainer({ freezeModal: true });
    }
  };

  handleQueryParams();

  // close if clicked outside
  contactUsContainer.addEventListener('click', (e) => {
    if (e.target === contactUsContainer) {
      closeMenu();
    }
  });
  Tracking.initialize();
}
